export const getDiscountPercentage = (origin: number, discounted: number): number => {
    const percent = (discounted / origin) * 100;

    if (!isNaN(percent)) {
        return Math.floor(100 - percent);
    }
    return 0;
};
